import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SpinnerModule } from '@uiowa/spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AgGridModule } from 'ag-grid-angular';
import { MerchantProfileService } from './services';
import { MerchantProfileFilter, UniversityPersonFilter, AccountStatusFilter } from './filters';
import { UniversityPersonComponent, WorkflowNotFoundComponent, WorkflowComponent, MerchantAccountListComponent } from './components';
import { PhoneMaskDirective } from './directives';
import { ConfirmationComponent, PersonModalComponent, MerchantProfileComponent, AddMerchantAccessUsersComponent, SetMerchantIdComponent, MerchantAccountTypeComponent } from './modals';
import { UniversityPersonModule } from '@uiowa/university-person';
import { WindowRefService } from './services/window.service';
import { ActionsComponent, PersonComponent } from './cell-renderers';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SpinnerModule,
        FontAwesomeModule,
        UniversityPersonModule,
        AgGridModule
    ],
    declarations: [
        MerchantProfileFilter,
        UniversityPersonFilter,
        UniversityPersonComponent,
        WorkflowNotFoundComponent,
        WorkflowComponent,
        MerchantAccountListComponent,
        PhoneMaskDirective,
        ConfirmationComponent,
        PersonModalComponent,
        MerchantProfileComponent,
        AddMerchantAccessUsersComponent,
        SetMerchantIdComponent,
        MerchantAccountTypeComponent,
        ActionsComponent,
        PersonComponent,
        AccountStatusFilter
    ],
    exports: [
        CommonModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        SpinnerModule,
        FontAwesomeModule,
        PhoneMaskDirective,
        UniversityPersonComponent,
        WorkflowNotFoundComponent,
        WorkflowComponent,
        MerchantAccountListComponent
    ],
    providers: [
        MerchantProfileService,
        WindowRefService
    ]
})
export class SharedModule {}
